import { IQuery } from 'core-ts-types';
import {
  IContentTileActionObj,
  IContentTileExpectedObj,
  IContentTileIconObj,
  IContentTileTextObj
} from 'ui-ng-content-tile';
import { IDatasource, Query } from 'utility-ts-orm';
import { TypeUtility } from 'utility-ts-type';
import { TimeFormatterFunction } from '../functions/time_formatter_fn';
import { PathItem } from './../builders/path_item_builder';
import { PathTask } from './../builders/path_task_builder';
import { PathTaskFormatter } from './../functions/path_task_formatter_fn';

export class EventPriorityFeedQuery implements IQuery {
  private _result: IContentTileExpectedObj;
  private _isActive: boolean;

  constructor(
    private ngPathTaskFormatter: PathTaskFormatter,
    private ngPathItemDatastore: IDatasource<PathItem>,
    private ngPathTaskDatastore: IDatasource<PathTask>,
    private ngTypeUtility: typeof TypeUtility,
    private EventCategoryEnum: any,
    private TaskStatusEnum: any
  ) {
    Query.registerQuery(this, this.ngPathItemDatastore, this.ngPathTaskDatastore);
  }

  run(): this {
    const apptItem = _.first(this.ngPathItemDatastore.query((item) => item.presenter === 'APPOINTMENT'));
    const eventsToday = this.ngPathTaskDatastore.query((task: PathTask) =>
      this.__getActiveEventsForToday(task, apptItem)
    );
    const isActive = (this._isActive = !_.isEmpty(eventsToday));

    const text = this.getEventText(eventsToday);
    const action = this.getEventState(eventsToday);
    const firstTask = _.first(eventsToday);
    const date = firstTask ? this.ngPathTaskFormatter.getCalendarDay(firstTask) : `${moment().date()}`;
    const icon = {
      type: 'empty_calendar',
      theme: 'blue',
      config: {
        isEventIcon: true,
        date
      }
    };
    this._result = {
      icon,
      text,
      action,
      isOverdue: false,
      isActive
    };

    return this;
  }

  private __getActiveEventsForToday(task: PathTask, apptItem: PathItem): boolean {
    const endOfDay = moment().endOf('day');
    const apptId = apptItem ? apptItem.id : undefined;
    return (
      this.TaskStatusEnum.isActive(task.status) &&
      task.show &&
      task.mandatory &&
      this.EventCategoryEnum.isDateMarker(task.category) &&
      (task.start_ts.isBefore(endOfDay) || task.end_ts.isBefore(endOfDay)) &&
      task.item !== apptId
    );
  }

  private getEventText(eventList: PathTask[]): IContentTileTextObj {
    if (eventList.length > 1 || !this._isActive) {
      return {
        title: `You have ${eventList.length} events happening today`,
        subTitle: 'Check them out'
      };
    }

    const priorityEventTask: PathTask = _.first(eventList);
    const priorityEventItem: PathItem = _.first(
      this.ngPathItemDatastore.query((item: PathItem) => item.id === priorityEventTask.item)
    );

    return {
      title: this.ngPathTaskFormatter.getToDoTitle(priorityEventTask, priorityEventItem),
      subTitle: this.getDateMessage(priorityEventTask)
    };
  }

  getDateMessage(task: PathTask): string {
    const today = moment();
    const validStart = !_.isEmpty(task.start_ts) && task.start_ts.isValid();
    const date = validStart ? task.start_ts : task.end_ts;
    const isToday = date.isAfter(today.startOf('day')) && date.isBefore(today.endOf('day'));
    const sameEndDate = moment(task.start_ts).diff(task.end_ts, 'days') === 0;
    if (isToday && sameEndDate) {
      return 'Today';
    }

    if (isToday && validStart) {
      return `Today - ${this.getEndDateMessage(task)}`;
    }

    if (sameEndDate) {
      return `${TimeFormatterFunction.defaultTime(task.start_ts)}`;
    }

    if (!validStart) {
      return `Due on ${this.getEndDateMessage(task)}`;
    }
    return `${TimeFormatterFunction.defaultTime(task.start_ts)} - ${this.getEndDateMessage(task)}`;
  }

  getEndDateMessage(task: PathTask): string {
    if (moment().diff(task.end_ts, 'days') === 0) {
      return 'Today';
    }
    return TimeFormatterFunction.defaultTime(task.end_ts);
  }

  private getEventState(eventList: PathTask[]): IContentTileActionObj {
    if (eventList.length > 1 || !this._isActive) {
      return {
        state: 'my.todos',
        params: {
          filterBy: 'eventstoday'
        }
      };
    }

    const priorityEventTask = _.first(eventList);
    return {
      state: 'my.todos.details',
      params: {
        eventId: priorityEventTask.event,
        repeatedBy: priorityEventTask.repeated_by
      }
    };
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/queries/events_priority_feed_query.ts